const getOpenTelemetryBaggageHttpHeaders = (): { [key: string]: string } => {
  const numberOfDevices = localStorage.getItem('userAttributes')
    ? JSON.parse(localStorage.getItem('userAttributes') || '{}').numberOfDevices
    : undefined;

  const isNumberOfDevicesValid = numberOfDevices || numberOfDevices === 0;

  return {
    ...(isNumberOfDevicesValid && {
      'ot-baggage-cobli-fleet-num-devices': numberOfDevices.toString(),
    }),
  };
};

export { getOpenTelemetryBaggageHttpHeaders };
